import { atom } from 'jotai';
import { DEFAULT_COORDINATES } from '../../../constants/Settings';

export interface GeocodeAddressState {
  // eslint-disable-next-line camelcase
  address_components?: any[];
  // eslint-disable-next-line camelcase
  formatted_address?: string;
}

export interface CoordsState {
  latitude: number;
  longitude: number;
  custom: boolean | string;
  geocodeAddress: GeocodeAddressState;
}

const INITIAL_COORDS: CoordsState = {
  latitude: DEFAULT_COORDINATES.latitude,
  longitude: DEFAULT_COORDINATES.longitude,
  custom: false,
  geocodeAddress: {
    formatted_address: '',
    address_components: []
  }
};

const STORAGE_KEY = 'rin-coords';

function loadFromStorage(): CoordsState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      return JSON.parse(raw);
    }
  } catch {
    // ignore
  }
  return INITIAL_COORDS;
}

const coordsAtom = atom<CoordsState>(loadFromStorage());

export { coordsAtom, INITIAL_COORDS };
